import { makeStyles } from '@material-ui/core/styles'
import bgImage from './img/bg2.jpg'

const useStyles = makeStyles((theme)=>({
    Container:{
        minHeight:'95vh',
        maxHeight: '100vh',
        padding: '2vh',
        backgroundImage: `url(${bgImage})`,
        backgroundPosition: 'center',
        backgroundSize: 'cover',
        overflowY : 'auto',
    },
    sideContent:{
        display: 'flex',
        flexWrap: 'nowrap',
        // backgroundColor: 'red',
    },
    mainContent:{
        display: 'flex',
        flexDirection: 'column',
        height: '100vh',
        // backgroundColor:'green',
    },
    content:{
        minHeight: '50vh',
        maxHeight: '80vh',
        // backgroundColor: '#910061',
    },
    ResumeContainer:{
        display:'flex',
        height: '100%',
        // minHeight: '70vh',
    },
    ResumeEdu:{
        backgroundColor: 'Orange',
    },
    ResumeExp:{
        backgroundColor: 'Red',
    },
    ResumeSSkill:{
        backgroundColor: 'Blue',
    },
    ResumeHSkill:{
        backgroundColor: 'Yellow',
    },
    ResumeTitleHeader:{
        textAlign: 'center',
    },
    portContainer:{
        minHeight:'50vh',
    }
}))

export default useStyles;